import React from 'react';
import * as Icons from '@material-ui/icons/';

import { SvgIcon } from "@material-ui/core";
import {ReactComponent as Product_icon_blue} from './icon_source/product_icon_blue.svg'
import {ReactComponent as Settings} from './icon_source/Settings.svg'
import {ReactComponent as Settings_White} from './icon_source/Settings_white.svg'
import {ReactComponent as Help} from './icon_source/help.svg'
import {ReactComponent as Dialog_icon} from './icon_source/dialog_icon.svg'
import {ReactComponent as Clear} from './icon_source/clear.svg'
import {ReactComponent as P_icon} from './icon_source/p.svg'
import {ReactComponent as Refresh} from './icon_source/refresh.svg'
import {ReactComponent as Dollar} from './icon_source/dollar.svg'
import {ReactComponent as Profile} from './icon_source/Profile.svg'
import {ReactComponent as Profile_Blue} from './icon_source/profile_blue.svg'
import {ReactComponent as Profile_Green} from './icon_source/profile_green.svg'
import {ReactComponent as Dollar_Blue} from './icon_source/dollar_blue.svg'
import {ReactComponent as Order} from './icon_source/order.svg'
import {ReactComponent as Back} from './icon_source/back.svg'
import {ReactComponent as Refresh_Black} from './icon_source/refresh_black.svg'
import {ReactComponent as Menual} from './icon_source/menual.svg'
import {ReactComponent as Price} from './icon_source/price.svg'



// export const Product_Blue_Icon = () => (
//     <SvgIcon>
//         <Product_icon_blue/>
//     </SvgIcon>
// )

// export const Setting_Icon = () => (
//     <SvgIcon>
//         <Settings/>
//     </SvgIcon>
// )

// export const Help_Icon = () => (
//     <SvgIcon>
//         <Help/>
//     </SvgIcon>
// )

const renderSwitch = (type:string) => {
    switch(type) {
        case 'Help':
            return <Help/>
        case 'Product_Blue':
            return <Product_icon_blue/>
        case 'Setting':
            return <Settings/>
        case 'Setting_White':
            return <Settings_White/>
        case 'Dialog':
            return <Dialog_icon/>
        case 'Clear':
            return <Clear/>
        case 'P':
            return <P_icon />
        case 'Refresh':
            return <Refresh/>
        case 'Dollar':
            return <Dollar/>
        case 'Profile':
            return <Profile/>
        case 'Profile_Blue':
            return <Profile_Blue/>
        case 'Dollar_Blue':
            return <Dollar_Blue/>
        case 'Order':
            return <Order/>
        case 'Refresh_Black':
            return <Refresh_Black/>
        case 'Back':
            return <Back/>
        case 'Menual':
            return <Menual/>
        case 'Profile_Green':
            return <Profile_Green/>
        case 'Price':
            return <Price/>       
    }
}

export const SIcon:React.FC<any> = (props) => {
    const {viewBox, style} = props
    let styles = {}
    if(style){
        styles={style}
    }
    else{
        styles={ textAlign: 'center' } 
    }

    return (
        <SvgIcon style={styles} viewBox={viewBox}>
            {renderSwitch(props.type)}
        </SvgIcon>
    )
}

type IconType = typeof import('@material-ui/icons/index');


// JUST USE https://material-ui.com/components/material-icons/ ICONS ONLY

interface DynamicIconProps {
    iconName: string,
    className: string
}

function upperFirst(string:string) {
    return string.slice(0, 1).toUpperCase() + string.slice(1, string.length)
}
  
function fixIconNames(string:string) {
    const name = string.split('-').map(upperFirst).join('')
    if (name === '3dRotation') {
        return 'ThreeDRotation'
    } else if (name === '4k') {
        return 'FourK'
    } else if (name === '360') {
        return 'ThreeSixty'
    }
    return name;
}

export default class DynamicIcon extends React.Component<DynamicIconProps> {
    constructor(props: DynamicIconProps) {
        super(props);
    }

    render() {
        const iconN = fixIconNames(this.props.iconName)
        // return (
        //     <Icon>{this.props.iconName}</Icon>    
        // )
        return React.createElement(Icons[fixIconNames(this.props.iconName)! as keyof IconType], {className: this.props.className});
    }
}